module.exports = __webpack_public_path__ + "static/img/b26.8dc047c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b26.jpg
// module id = kWIM
// module chunks = 1